import { render } from "./AiImportSettingComponent.vue?vue&type=template&id=254c849b"
import script from "./AiImportSettingComponent.vue?vue&type=script&lang=js"
export * from "./AiImportSettingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/AiImport/AiImportSettingComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "254c849b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('254c849b', __exports__)) {
    api.reload('254c849b', __exports__)
  }
  
  module.hot.accept("./AiImportSettingComponent.vue?vue&type=template&id=254c849b", () => {
    api.rerender('254c849b', render)
  })

}


export default __exports__